"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProcessModule = void 0;
const router_1 = require("client/components/router");
const payment_process_1 = require("./payment-process");
class PaymentProcessModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/patientPayments\/?$/, payment_process_1.PaymentProcessList);
    }
}
exports.PaymentProcessModule = PaymentProcessModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/payment-process/payment-process-module.tsx
// module id = 4161
// module chunks = 0